import { combineReducers } from 'redux';
import ajaxCallsInProgress from './ajaxStatusReducer';
import systems from './systemReducer';
import sites from './siteReducer';
import waterReadings from './waterReadingReducer';
import wasteReadings from './wasteReadingReducer';
import dailyLogs from './dailyLogReducer';
import dailyLogEntries from './dailyLogEntryReducer';
import repairLogs from './repairLogReducder';
import repairLogEntries from './repairLogEntryReducer';
import timeCards from './timeCardReducer';
import timeCardEntries from './timeCardEntryReducer';
import payPeriods from './payPeriodReducer';
import currentUser from './loginReducer';
import payPeriodWeeks from './payWeekReducer';
import users from './userReducer';
import userRoles from './userRoleReducer';
import images from './imageReducer';
import billingItems from './billingItemReducer';

const rootReducer = combineReducers({
  systems,
  sites,
  waterReadings,
  wasteReadings,
  dailyLogs,
  dailyLogEntries,
  repairLogs,
  repairLogEntries,
  images,
  billingItems,
  timeCards,
  timeCardEntries,
  payPeriods,
  payPeriodWeeks,
  currentUser,
  users,
  userRoles,
  ajaxCallsInProgress,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js